import {DateFormatter} from '../../../../modules/dateFormatter.js';

export const articleSearchItemTemplate = (item, {html, components}) => {
    const {url, objectID, __position, __queryID, published_at: datePublished} = item;

    const highlightedTitle = components.Highlight({
        attribute: 'title',
        hit: item,
        highlightedTagName: 'b',
    });

    const highlightedDescription = components.Highlight({
        attribute: 'description',
        hit: item,
        highlightedTagName: 'b',
    });

    return html`
        <div
                data-insights-object-id="${objectID}"
                data-insights-position="${__position}"
                data-insights-query-id="${__queryID}"
                class="searchItem searchItem--link pb-medium"
        >
            <div class="searchItem__type">Article</div>
            <h4 class="searchItem__heading h3 mt-none mb-small">
                <a class="searchItem__link" href="${url}">
                    ${highlightedTitle}
                </a>
            </h3>
            <div class="searchItem__tag">
                <span class="visually-hidden">Published: </span>${DateFormatter.diffForHumans(
                    new Date(Date.parse(datePublished))
                )}
            </div>
            <div class="searchItem__content">
                <p class="truncate-3 mb-small">${highlightedDescription}</p>
            </div>
            <div class="searchItem__callToAction link">Read article</div>
        </div>
    `;
};
